import { z } from "zod"

export const RoleFormSchema = z.object({
  name: z
    .string()
    .min(1, { message: "Role name is required" })
    .max(64, { message: "Role name must be less than 64 characters" }),

  permissionIds: z.array(z.string()).min(1, "Please select at least one permission option"),
})
